import { INavLink } from '@hwm/ui-lib';
import { useEffect } from 'react';
import { useGetLinks } from './MainMenu.utils';

export interface MainMenuProps {
  links: INavLink[];
  setLinks: (links: INavLink[]) => void;
}

export const MainMenu: React.FC<MainMenuProps> = ({ links, setLinks }) => {
  const { getMenu, menuComponent } = useGetLinks();

  useEffect(() => {
    if (links.length > 0) {
      links.splice(0, links.length);
    }

    links.push(...getMenu());
    setLinks(getMenu());
  }, [links, getMenu, setLinks]);

  return <>{menuComponent}</>;
};
